<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction>
          <template slot="buttons">
        <!-- <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="formBuilderButtonClicked()">
              <i class="icon-floppy-disk mr-2"></i>Form Builder
            </button>
          </div> -->
          </template>
       </PageHeaderNoAction>
      <div class="section-body">
        <DataFilter :gridId="gridId" :isExport="false" :hasNew="true" newLink="/Builder/ModelBuilder/request"></DataFilter>
        <SlickGrid :gridId="gridId" :editable="false" :frozenColumn="2" :isAutoInitData="true" baseUrl="/model_builder"/>
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import config from "@/config";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "Model Builder List",
  access_code: "MB_LIST01",
  icon: "fas fa-database fa-fw",
  components: {

  },
  order:6,
  data() {
    return {
      gridId: "list01",
      formData: {
        staff_name: ""
      }
    };
  },
  created() {
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    },
    dataList() {
      return this.grid.selectRows || [];
    },

  },
  mounted() {},
  methods: {
    ...mapActions("grid", ["actionResetGrid", "actionSetGrid", "actionRequest"]),
//   formBuilderButtonClicked(){
//  api.request(
//         this,
//         "post",
//         `/userBuildForm/createFormBuilder`,
//         {
//           SessionID: helper.getSessionID(),
//           LocaleCode: helper.getLocaleCode(),
//           Parameters: {
//             id: this.$route.params.id,
//             mb_form_id:this.dataList[0].id
//           }
//         },
//         function(r) {
//            window.open(
//           config.serverBase+"/formBuilder.html?id=" +
//             this.dataList[0].id,
//           "_blank"
//         );
//         },
//         function(r) {
//           helper.done();
//         },
//         null
//       );

//     },
  }
};
</script>

<style scoped>
.section-body{
  padding-top:100px
}
</style>